import Command from './command';
import EventBus from '@/factories/eventBus';

class OpenChatBot extends Command {
  id = 'openChatBot';
  icon = 'custom/ai';
  title = 'Ask CY';
  dynamicTitle = (search) => {
    return `Ask CY: "${search}"`;
  };
  wordTriggers = [
    'cy',
    'chatbot',
    'ai',
    'what',
    'who',
    'whom',
    'whose',
    'which',
    'when',
    'where',
    'why',
    'how',
    'ask',
    'tell',
    'say',
    'explain',
    'describe',
    'find',
    'can',
    'show',
    'list',
    'search',
    'help',
    'assist',
    'give',
    'provide',
    'offer',
    'recommend',
    'suggest',
    'explain',
    'clarify',
    'elaborate',
    'detail',
    'inquire',
  ];

  run(search) {
    EventBus.$emit('openChatBot', search);
    return true;
  }
}

export default OpenChatBot;
